import { render, staticRenderFns } from "./seikyu.vue?vue&type=template&id=6830a570&scoped=true&"
import script from "./seikyu.vue?vue&type=script&lang=js&"
export * from "./seikyu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6830a570",
  null
  
)

export default component.exports